import React from "react";
import "./style.scss";

const RegisterSuccess = () => {
  return (
    <section className="register-success-modal" data-testid="register-success">
      <h1 className="welcome-header">Your account is almost complete...</h1>
      <h3
        className="small-header u-align-center f-kicker api-header"
        data-testid="email-message"
      >
        To complete your account setup, please find the activation link in your
        email and follow the instructions to activate your account.
      </h3>
      <p className="u-margin-bottom-40 api-description">
        Any help you need to get started using our data can be found in the{" "}
        <a
          href="https://help.data.nasdaq.com"
          data-testid="helpdoc-link"
          target="_blank"
          rel="noreferrer"
        >
          help
        </a>{" "}
        section.
      </p>
    </section>
  );
};

export default RegisterSuccess;
